import { render, staticRenderFns } from "./KmAutomaticoView.vue?vue&type=template&id=23bf4ff2&scoped=true"
import script from "./KmAutomaticoView.vue?vue&type=script&lang=js"
export * from "./KmAutomaticoView.vue?vue&type=script&lang=js"
import style0 from "./KmAutomaticoView.vue?vue&type=style&index=0&id=23bf4ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bf4ff2",
  null
  
)

export default component.exports